import { Grid, IconButton, Modal } from "@mui/material";
import { Box, styled } from "@mui/system";
import { useState } from "react";
import img from '../../Assets/modal-link-img.svg';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover, bindToggle } from 'material-ui-popup-state';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../Config/PageRoutes";
import CloseIcon from '@mui/icons-material/Close';

const data = [
    {
        title: '',
        content: '',
        triggers: [],
        category: '',
        link: false
    },
    {
        title: 'EU MACP sampling procedure.',
        content: 'The EU MACP is defined under Regulation (EU) No 2019/533, which specifies combinations of pesticides (186 pesticides) and a minimum number of samples for 12 food products to be analysed by EU Member States.',
        triggers: ['minimum number', 'EU MACP', '3-year cycle', 'three-year cycle', 'given number of samples by commodity'],
        category: 'Methodology',
        link: false
    },
    {
        title: 'The Maximum Residue Level.',
        content: 'Means the upper legal level of a concentration for a pesticide residue in or on food or feed set in accordance with Annex I of Regulation (EC) 396/2005, based on good agricultural practice and the lowest consumer exposure necessary to protect vulnerable consumers.',
        triggers: ['MRL exceedances', 'MRL exceedance rate', 'MRL', 'MRLs', 'MRL exceedance rates'],
        category: 'Terminology',
        link: true
    },
    {
        title: 'Quantification',
        content: 'Term describes results where the analytes are not present in concentrations at or exceeding the limit of quantification (LOQ), as reported by the Member States. The LOQ is the smallest concentration of an analyte that can be quantified. It is commonly defined as the minimum concentration of the analyte in the test sample that can be determined with acceptable precision and accuracy.',
        triggers: ['quantifiable levels', 'quantifiable residues'],
        category: 'Methodology',
        link: true
    },
    {
        title: 'Limit of Quantification',
        content: 'The LOQ is the smallest concentration of an analyte that can be quantified. It is commonly defined as the minimum concentration of the analyte in the test sample that can be determined with acceptable precision and accuracy.',
        triggers: ['LOQ'],
        category: 'Methodology',
        link: true
    },
    {
        title: 'Non-compliant samples',
        content: 'Samples containing residue concentrations clearly exceeding the legal limits, considering the measurement uncertainty.',
        triggers: ['non-compliant', 'non-compliance rate', 'non-compliance rates'],
        category: 'Methodology',
        link: true
    },
    {
        title: 'Samples with quantified residues within the legal limits (below or at the MRL).',
        content: 'These samples contained quantified residues of one or several pesticides in concentrations below or at the MRL.',
        triggers: ['quantified at or above the limit of quantification', 'above the LOQ but below the MRL', 'above the LOQ but below or at the MRL', 'below the MRL', 'at or above the LOQ but below or equal to the MRL', 'below the LOQ'],
        category: 'Methodology',
        link: true
    },
    {
        title: 'Pesticide residues',
        content: 'A \'pesticide residue\' consists of or contains measurable amounts of an active substance and/or related metabolites and degradation products that can be found on harvested crops or in foods of animal origin.',
        triggers: ['Pesticide residues', 'pesticide residues', 'samples with multiple residues'],
        category: 'Terminology',
        link: true
    },
]



const ModalTrigger = (props) => {

    const navigate = useNavigate();

    const navigateToImportantConcepts = () => {
        navigate('../' + PageRoutes.IMPORTANT_CONCEPTS, { replace: true });
    }

    const found = data.find(d => d.triggers.indexOf(props.text) > -1);

    return (
        <PopupState variant="popover" popupId="demo-popup-popover">
            {(popupState) => (
                <>
                    <b {...bindTrigger(popupState)} style={{ cursor: 'pointer', color: '#246898' }}>{props.text}
                        <img  {...bindTrigger(popupState)} src={img} style={{ cursor: 'pointer' }} />
                    </b>

                    <Popover
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'center',
                        }}
                    >
                        <Box>
                            <Grid container flexDirection='column'>
                                <Grid item>
                                    <Box pt={'5px'} pl={'5px'} display='flex' sx={{ fontSize: '12px' }} alignItems='center' justifyContent='space-between'>
                                        <Box>
                                            <QuestionMarkIcon sx={{ fontSize: 12 }} /> | <span style={{ textTransform: 'uppercase' }}>{found.category}</span>
                                        </Box>
                                        <IconButton component="span" {...bindToggle(popupState)}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>
                                </Grid>
                                <Grid item>
                                    <Box pt={'10px'} pl={2} pr={2} sx={{ maxWidth: '360px' }}>
                                        <h3>{found.title}</h3>
                                        <p>{found.content}</p>
                                    </Box>
                                </Grid>
                                {
                                    found.link &&
                                    <Grid item>
                                        <Box pl={2} pb={1} display='flex' alignContent='center'>
                                            <p style={{
                                                margin: 0,
                                                padding: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}><b>More important concepts</b></p>
                                            <IconButton onClick={navigateToImportantConcepts}>
                                                <ArrowForwardOutlinedIcon />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                }
                            </Grid>
                        </Box>
                    </Popover>
                </>
            )
            }
        </PopupState >

    );

}

export default ModalTrigger;